import { Capacitor } from "@capacitor/core";

/**
 * True when running inside a Capacitor native shell (iOS/Android), false on web.
 *
 * Use this to hide cross-portal / cross-domain CTAs that rely on
 * `getPortalUrl()` — inside the `capacitor://localhost` webview those resolve to
 * relative paths and would navigate in-app incorrectly. Each native build is a
 * single portal (Consumer / Merchant / Agent), so cross-portal links are N/A.
 */
export function isNativeApp(): boolean {
  return Capacitor.isNativePlatform();
}

/**
 * Auth-email redirect target. On web returns null (callers fall back to
 * window.location); on native returns the app's custom-scheme deep link so
 * Supabase confirm/recovery emails reopen the app. The scheme equals the appId
 * (com.valuegiftvouchers.<portal>), derived from the build-time VITE_PORTAL.
 * `host` distinguishes the flow so the deep-link handler can route it.
 */
export function nativeAuthRedirect(host: "login-callback" | "reset-callback"): string | null {
  if (!isNativeApp()) return null;
  const portal = import.meta.env.VITE_PORTAL as string | undefined;
  if (!portal) return null;
  return `com.valuegiftvouchers.${portal}://${host}`;
}
